import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FalconComponentCard from "components/common/FalconComponentCard";
import BackButton from "components/common/custom/back-button";
import { Button, Col } from "react-bootstrap";
import { FiDownloadCloud } from "react-icons/fi";
import paths from "routes/paths";
import PaymentListFilter from "./components/PaymentListFilter.js";
import PaymentListTable from "./components/PaymentListTable.js";
import { handleResetAll } from "features/preauthorization/config/preauthorizationSlice.js";
import {
  handlePreauthFormData,
  handleResetCreateClaim,
} from "features/cliams/config/claimSlice.js";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice.js";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { GetAllClaimPayment } from "./config/PaymentApi.js";
import { handleResetFilter } from "./config/PaymentSlice.js";
import { handleDownloadXLSX } from "helpers/excel/index.js";
const PaymentList = () => {
  const dispatch = useDispatch();
  const { paymentFilters, allPaymentList } = useSelector((state) => state.Payment);

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));



  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {
    control,
    watch,
    handleSubmit,
    setValue,
    reset,
    clearErrors,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      payer: "",
      insurance: "",
      payment_number: "",
      claim_number: "",
      status: "",
      by_batch: false,
      by_received_date: false,
      start_date: "",
      end_date: "",
    },
  });

  const requestBody = (customPage = page, customLimit = rowsPerPage) => ({
    branch_id: paymentFilters?.branch_id?.branch_id ||
      selectedBranch?.branch_id ||
      selectedBranch?.value ||
      "",
    payer_id: paymentFilters?.payer?.payer_id,
    insurance_company_id: paymentFilters?.insurance?.insurance_company_id || '',
    frm_dte: paymentFilters?.start_date
      ? moment(paymentFilters?.start_date).format("YYYY-MM-DD")
      : "",
    to_dte: paymentFilters?.end_date
      ? moment(paymentFilters?.end_date).format("YYYY-MM-DD")
      : "",
    pay_status: paymentFilters?.status?.value || '',
    start_point: customPage,
    limit: customLimit,
  });



  const fetchPaymentList = async (body = {}) => {
    try {
      const response = await dispatch(
        GetAllClaimPayment(body)
      ).unwrap();
      setTotalRows(response?.total_rows || 0);
    } catch (error) {
      toast.error("Something Went Wrong");
    }
  };
  const handleCheckListFilter = () => {
    const newPage = 0;
    setPage(newPage); // Reset page
    const body = requestBody(newPage, rowsPerPage);
    fetchPaymentList(body);
  };

  // ✅ Pagination handlers
  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePerRowsChange = useCallback((newPerPage) => {
    setRowsPerPage(newPerPage);
    setPage(0);
  }, []);

  useEffect(() => {
    const body = requestBody(page, rowsPerPage);
    fetchPaymentList(body);
  }, [page, rowsPerPage]);
  useEffect(() => {
    dispatch(handleResetAll({ check: "reset" }));
    dispatch(handleResetCreateClaim());
    dispatch(handlePreauthFormData({ check: "reset" }));
    dispatch(handleResetPatientSearch());
  }, []);

  const handleDownloadExcel = async () => {
    const excelBody = {
      branch_id: paymentFilters?.branch_id?.branch_id ||
        selectedBranch?.branch_id ||
        selectedBranch?.value ||
        "",
      payer_id: paymentFilters?.payer?.payer_id,
      insurance_company_id: paymentFilters?.insurance?.insurance_company_id,
      frm_dte: paymentFilters?.start_date
        ? moment(paymentFilters?.start_date).format("YYYY-MM-DD")
        : "",
      to_dte: paymentFilters?.end_date
        ? moment(paymentFilters?.end_date).format("YYYY-MM-DD")
        : "",
      pay_status: paymentFilters?.status?.value || '',
      start_point: 0,
      limit: 100000,
    }
    const data = await dispatch(GetAllClaimPayment(excelBody)).unwrap();
    const paymentData = data?.data || [];
    const flattenedArray =
      paymentData &&
      paymentData?.length > 0 &&
      paymentData?.map((row, index) => [
        index + 1,
        row?.insurance_direct === 0
          ? `${row?.payer_name} - ${row?.insurance_shname}`
          : row?.payer_name || "",
        row.created_at
          ? moment(row?.updated_at || row.created_at).format(
            "DD-MM-YYYY , hh:mm:ss A"
          )
          : "-" || "-",
        row?.insurance_code || "",
        row?.paymentno || "",
        row?.start_date ? moment(row?.start_date).format("DD-MM-YYYY") : '',
        row?.end_date ? moment(row?.end_date).format("DD-MM-YYYY") : '',
        row?.amount || 0,
        row?.totalclaim || 0,
        row?.pay_status || "",
      ]);
    handleDownloadXLSX(
      [
        [
          "#",
          "Payer Name",
          "Create Date",
          "Insurance Code",
          "Payment No.",
          "Period Start Date",
          "Period End Date",
          "Amount",
          "Total Claim",
          "Status"
        ],
        ...(flattenedArray || []),
      ],
      `Payment_List_Export_${moment().format("DD-MM-YYYY_hh:mm:ss")}`
    );

  };

  const handleReset = async () => {
    reset({
      payer: "",
      insurance: "",
      payment_number: "",
      claim_number: "",
      status: "",
      by_batch: false,
      by_received_date: false,
      start_date: "",
      end_date: "",
    });

    const resetBody = {
      payer_id: '',
      insurance_company_id: '',
      frm_dte: '',
      to_dte: '',
      pay_status: '',
      start_point: 0,
      limit: 10,
    }
    setPage(0);
    setRowsPerPage(10);
    dispatch(handleResetFilter());
    await fetchPaymentList(resetBody);
  };

  return (
    <FalconComponentCard>
      <FalconComponentCard.Header className="d-flex fixed-header justify-content-between align-items-center">
        <BackButton path={paths.claimsList} title="Payments" />
        <Col xs="auto" className="d-flex gap-2">
          <Button size="sm" variant="outline-danger" onClick={handleReset} >
            Reset
          </Button>
          <Button
            type="submit"
            size="sm"
            variant="success"
            onClick={handleSubmit(handleCheckListFilter)}
          >
            Filter
          </Button>
          <Button size="sm" variant="warning" onClick={handleDownloadExcel}>
            <FiDownloadCloud size={16} />
            Excel
          </Button>
        </Col>
      </FalconComponentCard.Header>

      <FalconComponentCard.Body
        style={{
          marginTop: "40px",
          overflowY: "auto",
          maxHeight: "calc(100vh - 200px)",
        }}
      >
        <PaymentListFilter
          onSubmit={handleCheckListFilter}
          setValue={setValue}
          watch={watch}
          control={control}
          isSubmitted={isSubmitted}
          clearErrors={clearErrors}
          errors={errors}
        />
        <PaymentListTable
          data={allPaymentList}
          handlePageChange={handlePageChange}
          requestBody={requestBody(page, rowsPerPage)}
          fetchPaymentList={fetchPaymentList}
          handlePerRowsChange={handlePerRowsChange}
          totalRows={totalRows}
          page={page}
          rowsPerPage={rowsPerPage}
        />
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
};

export default PaymentList;
